import { apiCall } from "./authServices";

export const GetAllMvrName = async ({payload}) => {
    try{
        const endpoint = `api/analytics/get-active-mvr-manuals`;
        const res = await apiCall({
            endpoint: endpoint,
            method: 'POST',
            payload: payload
        });
        return res;
    }catch(error){
        throw error
    }
}

export const GetParameterPerMvr = async ({payload}) => {
    try{
        const endpoint = `api/analytics/get-parameters-per-mvr`;
        const res = await apiCall({
            endpoint: endpoint,
            method: 'POST',
            payload: payload
        });
        return res;
    }catch(error){
        throw error
    }
}

export const GetChecklistScore = async ({payload}) => {
    try{
        const endpoint = `api/analytics/get-checklist-per-mvr-parameters`
        const res = await apiCall({
            endpoint: endpoint,
            method: "POST",
            payload: payload,
        })
        return res;
    }catch(error){
        throw error;
    }
}